import { Field } from 'ngx-angular-query-builder';
import { FilterOperators, FieldMetadataCollection, FilterFieldProvider, FieldMetadataCollectionBuilder } from '@common/filter/filtering';
import { WidgetConfiguration } from '@feature/widget-configs/models/widget-configuration';
import { Currency } from '@currency/models/currency.model';
import { termination_status, vat_applies } from '../head-lease-schedule-types';
import { LeaseType } from '@feature/leases/models/lease-type';


export class AdminHeadLeaseWidgetFilterFieldProvider implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(widgetConfig: WidgetConfiguration, private readonly currencies: Currency[], private readonly leaseTypes: LeaseType[]) {  

    
    const addFilter = (label: string,
      optionsName: string,
      type: string,
      ops: string[], options: any[] = undefined) => this.fieldMetaDataCollection.addFilter(label, optionsName, type, ops, options);


      addFilter('Termination Status','SystemHeadLeaseTerminationStatus', 'string', FilterOperators.StringDefaults, termination_status.map(x=>{
        return {
          label: x,
          name: x,
          value: x
        }
      }));
      addFilter('Start Date','SystemHeadLeaseTermStartDate', 'date', FilterOperators.AdminDateDefaults);
      addFilter('End Date','SystemHeadLeaseTermEndDate', 'date', FilterOperators.AdminDateDefaults);
      addFilter('Lease Dated','SystemHeadLeaseLeaseDated', 'date', FilterOperators.AdminDateDefaults);
      addFilter('Currency', 'SystemHeadLeaseDefaultCurrencyCode', 'string', FilterOperators.StringDefaults, this.currencies.map((x: Currency) => {
        return {
          label: x.Code,
          name: x.Code,
          value: x.Code
        }
      }));

      addFilter('Lease Type','SystemLeaseTypeCode', 'string', FilterOperators.StringDefaults, leaseTypes.map(x =>{
        return {
          label: x.Code,
          name: x.Code,
          value: x.Code
        }
      }));
      addFilter('Passing Rent','SystemHeadLeasePassingRent', 'number', FilterOperators.AdminScalar);
      addFilter('Service Charge Amount','SystemHeadLeaseAnnualSC', 'number', FilterOperators.AdminScalar);
      addFilter('VAT on Rent Applies','SystemHeadLeaseVatOnRentApplies', 'string', FilterOperators.StringDefaults, vat_applies.map(x=>{
        return {
          label: x,
          name: x,
          value: x
        }
      }));
      addFilter('VAT on S/C Applies','SystemHeadLeaseVatOnSCApplies', 'string', FilterOperators.StringDefaults, vat_applies.map(x=>{
        return {
          label: x,
          name: x,
          value: x
        }
      }));
  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }


}
